import { bind } from 'app/_decorators/bind.decorator';
import * as angular from 'angular';
import { ComfortBidWizardCtx, mgoAngularWizard } from '../custom';

class ComfortBidWizardNetworkPointComponentCtrl implements ng.IController {
    wizardCtrl: mgoAngularWizard.Wizard<ComfortBidWizardCtx>;

    constructor(private createComfortBidService: { [p: string]: any }) {}

    $onInit(): void {
        const preSelectedNetworkPoint: NetworkPointDto =
            this.createComfortBidService.getNetworkPoint();

        // We clear up the data in the wizzard anytime
        // when user comes to network point selection page
        this.wizardCtrl.reset();
        this.wizardCtrl.context.data = [];
        if (preSelectedNetworkPoint != null) {
            this.wizardCtrl.context.selectedNetworkPoint =
                preSelectedNetworkPoint;
        }
    }

    public nextStep() {
        this.wizardCtrl.next();
    }

    @bind
    onNetworkPointSelection(selectedNetworkPoints: NetworkPointDto): void {
        this.wizardCtrl.context.selectedNetworkPoint = selectedNetworkPoints;
    }
}

angular.module('app').component('pkpComfortBidWizardNetworkPoint', {
    controller: ComfortBidWizardNetworkPointComponentCtrl,
    template:
        require('app/comfort-bid/comfort-bid-wizard-network-point.component.html'),
    require: {
        wizardCtrl: '^^wizard'
    },
    bindings: {}
});
